import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = { class: "relative sm:w-[265px]" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "trezo-card-subtitle mt-[15px] sm:mt-0" }
const _hoisted_7 = { class: "trezo-card-dropdown relative" }
const _hoisted_8 = { class: "inline-block relative ltr:pr-[17px] ltr:md:pr-[20px] rtl:pl-[17px] rtl:ml:pr-[20px]" }
const _hoisted_9 = {
  key: 0,
  class: "trezo-card-dropdown-menu transition-all bg-white shadow-3xl rounded-md top-full py-[15px] absolute ltr:right-0 rtl:left-0 w-[195px] z-[5] dark:bg-dark dark:shadow-none"
}
const _hoisted_10 = { class: "trezo-card-content -mx-[20px] md:-mx-[25px]" }
const _hoisted_11 = { class: "table-responsive overflow-x-auto" }
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = { class: "text-black dark:text-white" }
const _hoisted_14 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_15 = { class: "form-check relative top-[2px]" }
const _hoisted_16 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_17 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_18 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_19 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_20 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_21 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap" }
const _hoisted_22 = { class: "text-black dark:text-white" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  colspan: "7",
  class: "text-center py-4"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  colspan: "7",
  class: "text-center py-4"
}
const _hoisted_27 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_28 = { class: "form-check relative top-[2px]" }
const _hoisted_29 = ["value"]
const _hoisted_30 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_31 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_32 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_33 = { class: "flex items-center" }
const _hoisted_34 = { class: "rounded-md w-[40px] rounded-full" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_37 = { class: "block font-medium" }
const _hoisted_38 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_39 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_40 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_41 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_42 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_43 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]" }
const _hoisted_44 = { class: "flex items-center gap-[9px]" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 0,
  class: "fixed inset-0 z-50 overflow-y-auto"
}
const _hoisted_49 = { class: "flex items-center justify-center min-h-screen p-4" }
const _hoisted_50 = { class: "relative bg-white dark:bg-[#0c1427] rounded-lg shadow-xl max-w-md w-full p-6 z-50" }
const _hoisted_51 = { class: "flex justify-between items-center mb-4" }
const _hoisted_52 = { class: "text-lg font-medium text-gray-900 dark:text-white" }
const _hoisted_53 = { class: "space-y-4" }
const _hoisted_54 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_55 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_56 = { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }
const _hoisted_57 = { value: "active" }
const _hoisted_58 = { value: "deactive" }
const _hoisted_59 = { class: "flex justify-end space-x-3 mt-4" }
const _hoisted_60 = {
  key: 1,
  class: "fixed inset-0 z-50 overflow-y-auto"
}
const _hoisted_61 = { class: "flex items-center justify-center min-h-screen p-4" }
const _hoisted_62 = { class: "relative bg-white dark:bg-[#0c1427] rounded-lg shadow-xl max-w-md w-full p-6 z-50" }
const _hoisted_63 = { class: "flex justify-between items-center mb-4" }
const _hoisted_64 = { class: "text-lg font-medium text-gray-900 dark:text-white" }
const _hoisted_65 = { class: "space-y-6" }
const _hoisted_66 = { class: "flex justify-center" }
const _hoisted_67 = { class: "rounded-full w-24 h-24 overflow-hidden" }
const _hoisted_68 = ["src"]
const _hoisted_69 = { class: "space-y-4" }
const _hoisted_70 = { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }
const _hoisted_71 = { class: "text-gray-900 dark:text-white font-medium" }
const _hoisted_72 = { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }
const _hoisted_73 = { class: "text-gray-900 dark:text-white font-medium" }
const _hoisted_74 = { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }
const _hoisted_75 = { class: "text-gray-900 dark:text-white font-medium" }
const _hoisted_76 = { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }
const _hoisted_77 = { class: "text-gray-900 dark:text-white font-medium" }
const _hoisted_78 = { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }
const _hoisted_79 = { class: "text-gray-900 dark:text-white font-medium" }
const _hoisted_80 = { class: "text-gray-900 dark:text-white font-medium" }
const _hoisted_81 = { class: "flex justify-end space-x-3 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pagination = _resolveComponent("Pagination")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", _hoisted_4, [
          _cache[18] || (_cache[18] = _createElementVNode("label", { class: "leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2" }, [
            _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " search ")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            type: "text",
            placeholder: _ctx.directT('contacts.searchContacts'),
            class: "bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400"
          }, null, 8, _hoisted_5), [
            [_vModelText, _ctx.searchQuery]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "trezo-card-dropdown-btn inline-block rounded-md border border-gray-100 py-[5px] md:py-[6.5px] px-[12px] md:px-[19px] transition-all hover:bg-gray-50 dark:border-[#172036] dark:hover:bg-[#0a0e19]",
            id: "dropdownToggleBtn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args)))
          }, [
            _createElementVNode("span", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.getDisplayStatusFilter()) + " ", 1),
              _cache[19] || (_cache[19] = _createElementVNode("i", { class: "ri-arrow-down-s-line text-lg absolute ltr:-right-[3px] rtl:-left-[3px] top-1/2 -translate-y-1/2" }, null, -1))
            ])
          ]),
          (_ctx.showDropdown)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setStatusFilter('All')))
                  }, _toDisplayString(_ctx.directT('contacts.all')), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setStatusFilter('active')))
                  }, _toDisplayString(_ctx.directT('contacts.active')), 1)
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "block w-full transition-all text-black ltr:text-left rtl:text-right relative py-[8px] px-[20px] hover:bg-gray-50 dark:text-white dark:hover:bg-black",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setStatusFilter('deactive')))
                  }, _toDisplayString(_ctx.directT('contacts.inactive')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("table", _hoisted_12, [
          _createElementVNode("thead", _hoisted_13, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "cursor-pointer",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectAll) = $event)),
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
                  }, null, 544), [
                    [_vModelCheckbox, _ctx.selectAll]
                  ])
                ])
              ]),
              _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.directT('contacts.id')), 1),
              _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.directT('contacts.name')), 1),
              _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.directT('contacts.phone')), 1),
              _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.directT('contacts.lastContacted')), 1),
              _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.directT('contacts.status')), 1),
              _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.directT('contacts.actions')), 1)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_22, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                  _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.directT('contacts.loading')), 1)
                ]))
              : (_ctx.filteredContacts.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                    _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.directT('contacts.noContactsFound') || 'No contacts found'), 1)
                  ]))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredContacts, (contact) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: contact.id
              }, [
                _createElementVNode("td", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      class: "cursor-pointer",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedContacts) = $event)),
                      value: contact.id
                    }, null, 8, _hoisted_29), [
                      [_vModelCheckbox, _ctx.selectedContacts]
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, " #" + _toDisplayString(contact.id.substring(0, 4)), 1)
                ]),
                _createElementVNode("td", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("img", {
                        src: contact.profile_picture_link || _ctx.getRandomUserImage(),
                        class: "inline-block rounded-full",
                        alt: "contact-image"
                      }, null, 8, _hoisted_35)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("span", _hoisted_37, _toDisplayString(contact.name), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_38, [
                  _createElementVNode("span", _hoisted_39, _toDisplayString(contact.phone || _ctx.directT('contacts.notAvailable')), 1)
                ]),
                _createElementVNode("td", _hoisted_40, [
                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.formatDate(contact.last_contact)), 1)
                ]),
                _createElementVNode("td", _hoisted_42, [
                  _createElementVNode("span", {
                    class: _normalizeClass({
                    'px-[8px] py-[3px] inline-block rounded-sm font-medium text-xs': true,
                    'bg-primary-50 dark:bg-[#15203c] text-primary-500': contact.status === 'active',
                    'bg-orange-100 dark:bg-[#15203c] text-orange-600': contact.status === 'deactive'
                  })
                  }, _toDisplayString(_ctx.getStatusDisplay(contact.status)), 3)
                ]),
                _createElementVNode("td", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      type: "button",
                      class: "text-primary-500 leading-none custom-tooltip",
                      onClick: ($event: any) => (_ctx.viewContact(contact))
                    }, _cache[20] || (_cache[20] = [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " visibility ", -1)
                    ]), 8, _hoisted_45)), [
                      [_directive_tooltip, _ctx.directT('contacts.viewContact')]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      type: "button",
                      class: "text-gray-500 dark:text-gray-400 leading-none custom-tooltip",
                      onClick: ($event: any) => (_ctx.editContact(contact))
                    }, _cache[21] || (_cache[21] = [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                    ]), 8, _hoisted_46)), [
                      [_directive_tooltip, _ctx.directT('contacts.editContact')]
                    ]),
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      type: "button",
                      class: "text-danger-500 leading-none custom-tooltip",
                      onClick: ($event: any) => (_ctx.deleteContact(contact.id))
                    }, _cache[22] || (_cache[22] = [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                    ]), 8, _hoisted_47)), [
                      [_directive_tooltip, _ctx.directT('contacts.deleteContact')]
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createVNode(_component_Pagination, {
        "current-page": _ctx.currentPage,
        "total-items": _ctx.totalContacts,
        "items-per-page": _ctx.itemsPerPage,
        onPageChanged: _ctx.handlePageChange,
        class: "px-[20px] md:px-[25px]"
      }, null, 8, ["current-page", "total-items", "items-per-page", "onPageChanged"])
    ]),
    (_ctx.showEditPopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "fixed inset-0 bg-black opacity-50" }, null, -1)),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("h3", _hoisted_52, _toDisplayString(_ctx.directT('contacts.editContactTitle')), 1),
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeEditPopup && _ctx.closeEditPopup(...args))),
                  class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                }, _cache[23] || (_cache[23] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-xl" }, "close", -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.directT('contacts.name')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editForm.name) = $event)),
                    class: "bg-gray-50 border border-gray-100 p-2 rounded-md w-full text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                  }, null, 512), [
                    [_vModelText, _ctx.editForm.name]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.directT('contacts.phone')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editForm.phone) = $event)),
                    class: "bg-gray-50 border border-gray-100 p-2 rounded-md w-full text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                  }, null, 512), [
                    [_vModelText, _ctx.editForm.phone]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.directT('contacts.status')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editForm.status) = $event)),
                    class: "bg-gray-50 border border-gray-100 p-2 rounded-md w-full text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]"
                  }, [
                    _createElementVNode("option", _hoisted_57, _toDisplayString(_ctx.directT('contacts.active')), 1),
                    _createElementVNode("option", _hoisted_58, _toDisplayString(_ctx.directT('contacts.inactive')), 1)
                  ], 512), [
                    [_vModelSelect, _ctx.editForm.status]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" }, "Profile Picture URL", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.editForm.profile_picture_link) = $event)),
                    class: "bg-gray-50 border border-gray-100 p-2 rounded-md w-full text-black dark:bg-[#15203c] dark:text-white dark:border-[#172036]",
                    placeholder: "Leave empty to use default image"
                  }, null, 512), [
                    [_vModelText, _ctx.editForm.profile_picture_link]
                  ])
                ]),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("button", {
                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.closeEditPopup && _ctx.closeEditPopup(...args))),
                    class: "px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-[#172036] hover:bg-gray-50 dark:hover:bg-[#0a0e19]"
                  }, _toDisplayString(_ctx.directT('contacts.cancel')), 1),
                  _createElementVNode("button", {
                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.saveContactChanges && _ctx.saveContactChanges(...args))),
                    class: "px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-500 hover:bg-primary-600"
                  }, _toDisplayString(_ctx.directT('contacts.save')), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showViewPopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "fixed inset-0 bg-black opacity-50" }, null, -1)),
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("h3", _hoisted_64, _toDisplayString(_ctx.directT('contacts.contactDetails')), 1),
                _createElementVNode("button", {
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeViewPopup && _ctx.closeViewPopup(...args))),
                  class: "text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                }, _cache[26] || (_cache[26] = [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-xl" }, "close", -1)
                ]))
              ]),
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("img", {
                      src: _ctx.currentViewContact?.profile_picture_link || _ctx.getRandomUserImage(),
                      class: "w-full h-full object-cover",
                      alt: "Contact profile"
                    }, null, 8, _hoisted_68)
                  ])
                ]),
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.directT('contacts.id')), 1),
                    _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.currentViewContact?.id), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.directT('contacts.name')), 1),
                    _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.currentViewContact?.name), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.directT('contacts.phone')), 1),
                    _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.currentViewContact?.phone || _ctx.directT('contacts.notAvailable')), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_76, _toDisplayString(_ctx.directT('contacts.lastContacted')), 1),
                    _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.formatDate(_ctx.currentViewContact?.last_contact)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.directT('contacts.status')), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass({
                      'px-[8px] py-[3px] inline-block rounded-sm font-medium text-xs': true,
                      'bg-primary-50 dark:bg-[#15203c] text-primary-500': _ctx.currentViewContact?.status === 'active',
                      'bg-orange-100 dark:bg-[#15203c] text-orange-600': _ctx.currentViewContact?.status === 'deactive'
                    })
                      }, _toDisplayString(_ctx.currentViewContact ? _ctx.getStatusDisplay(_ctx.currentViewContact.status) : ''), 3)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Created At", -1)),
                    _createElementVNode("div", _hoisted_79, _toDisplayString(_ctx.formatDate(_ctx.currentViewContact?.created_at)), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _cache[28] || (_cache[28] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-500 dark:text-gray-400 mb-1" }, "Updated At", -1)),
                    _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.formatDate(_ctx.currentViewContact?.updated_at)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createElementVNode("button", {
                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeViewPopup && _ctx.closeViewPopup(...args))),
                    class: "px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-[#172036] hover:bg-gray-50 dark:hover:bg-[#0a0e19]"
                  }, _toDisplayString(_ctx.directT('contacts.close')), 1),
                  _createElementVNode("button", {
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.editContact(_ctx.currentViewContact))),
                    class: "px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-500 hover:bg-primary-600"
                  }, _toDisplayString(_ctx.directT('contacts.editContact')), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}